<template>
  <SegmentList
    data-heap="lite-queries-list"
    :segments="segments"
    :loading="loading"
    :test-id="'lite-queries-list'"
    @item-click="selectSegment"
    ><template #static-item>
      <SegmentListItem
        :segment="allClientsFakeSegment"
        :loading="loading"
        @item-click="selectAllClients"
      >
      </SegmentListItem> </template
  ></SegmentList>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSegmentsStore } from '@app/insights/store/segments'
import { useSharedSegment } from '@app/insights/composables/use-shared-segment'
import type { Segment } from '../../types/index'
import SegmentListItem from './segment-list-item.vue'
import SegmentList from './segment-list.vue'

const segmentsStore = useSegmentsStore()
const { segments, segment } = storeToRefs(segmentsStore)
const { allClientsFakeSegment, selectAllClients } = useSharedSegment()

const loading = false

const selectSegment = (clicked: Segment): void => {
  if (!segment.value || segment.value.id !== clicked.id) {
    segmentsStore.loadSegment(clicked)
  }
}
</script>
